module.exports = __webpack_public_path__ + "img/Banner01.8dff5e61.jpg";